<template>
  <div class="ability-detail">
    <h4 class="page-title my-3">{{ form.name }}</h4>
    <el-card>
      <target-detail :form="form"></target-detail>
      <div class="text-center">
        <el-button type="primary" size="medium" @click="handleBack">返回</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import TargetDetail from '@/components/ability/TargetDetail.vue'
export default {
  components: {
    TargetDetail,
  },
  data() {
    return {
      letters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
      form: {
        name: '',
        list: [],
      },
    }
  },
  mounted() {
    this.getCapabilityFrameDetail()
  },
  methods: {
    getCapabilityFrameDetail() {
      this.$store
        .dispatch('capability/getCapabilityFrameDetail', this.$route.params.id)
        .then((res) => {
          console.log('getCapabilityFrameDetail:', res)
          if (res.code === 1) {
            this.form = res.data
          }
        })
        .catch((err) => {
          console.log('err:', err)
        })
    },
    handleBack() {
      this.$router.push({
        path: '/ability-framework/index',
      })
    }
  },
}
</script>
<style lang="scss" scoped>
.ability-detail {
  .page-title {
    font-weight: 600;
  }
  ::v-deep {
    .el-form {
      .el-form-item__content {
        .el-form-item {
          &__label {
            color: #6C757D;
            width: 130px!important;
          }
          &__content {
            color: #343A40;
            line-height: 1.5!important;
            margin-left: 130px!important;
          }
        }
      }
    }
  }
}
</style>
